<script setup>
import { onMounted, ref } from 'vue'
import { getStateName } from '@/libs/utils/workflows.js'
import { calcPerc } from '@/libs/utils.js'

import QuestionGroupStatistics from '@/components/PollTemplate/Components/QuestionGroupStatistics.vue'

const props = defineProps(['currentQuestion', 'workflow', 'workflows'])

const customAnswersTypes = ref([
  'radio',
  'select',
  'checkbox'
])

const totAnswers = ref({})

onMounted(async () => {
  getTotAnswersForCustomTypes();
})

const getTotAnswersForCustomTypes = () => {
  if (props.currentQuestion.answers === null && customAnswersTypes.value.includes(props.currentQuestion.type)) {
    props.currentQuestion.additionalProperties.select_values.forEach(answers => {
      answers?.answers.forEach(answer => {
        totAnswers.value[answer.state] = (totAnswers.value[answer.state] ?? 0) + answer.num
      })
    })
  }
}

function getDependantQuestionConditionLabel() {
  return (childGroup) => {
    let label = ''
    props.currentQuestion['additionalProperties']['select_values'].forEach((el) => {
      if (el.value === childGroup['dependentQuestionCondition']) {
        label = el.label
      }
    })

    return label
  }
}

</script>

<template>
  <div class="card q-statistic mb-2">
    <div class="card-body">
      <h6>{{ currentQuestion.text }}</h6>
      <div v-if="currentQuestion.answers && currentQuestion.answers.length > 0">
        <ul class="list-group">
          <li class="list-group-item d-flex justify-content-between align-items-start"
              v-for="(answer, index) in currentQuestion['answers']"
              :key="index"
          >
            <span class="flex-grow-1 pe-2">
              {{ answer.value }}
            </span>

            <span class="badge bg-primary rounded-pill">
              {{ answer.num }}
              <span v-if="workflows">
                {{ getStateName(answer.state, workflows) }}
              </span>
            </span>
          </li>
        </ul>
      </div>
      <div v-else-if="currentQuestion.answers === null && customAnswersTypes.includes(currentQuestion.type)">
        <ul class="list-group">
          <li class="list-group-item"
              v-for="(response, index) in currentQuestion['additionalProperties']['select_values']" :key="index">
            <span>{{ response.label }}</span>

            <span v-for="(answer) in response.answers"
                  :key="answer"
                  class="badge bg-primary rounded-pill float-end mx-1"
            >
              {{ answer.num }}
              <span v-if="workflows">
                {{ getStateName(answer.state, workflows) }}
              </span>
            </span>
            <div class="col-12" v-if="response.answers.length">
              <div class="col-12" v-for="(answer, key) in response.answers" :key="key">
                <div class="col-12 progress mt-2" style="height:10px;">
                  <div class="progress-bar"
                       role="progressbar"
                       aria-label="Percentuale risposte"
                       :style="'width: '+calcPerc(answer, totAnswers) +'%;'"
                       :aria-valuenow="calcPerc(answer, totAnswers)"
                       aria-valuemin="0" aria-valuemax="100"
                  >
                  </div>
                </div>
                <span class="fw-bold small">
                  {{ getStateName(answer.state, props.workflows) }} - {{calcPerc(answer, totAnswers)}} %
                </span>
              </div>
            </div>
          </li>
        </ul>
        <div class="mt-3" v-for="(childGroupQuestion) in currentQuestion['childQuestionGroups']"
             :key="childGroupQuestion.id">
          <p class="mb-1">Condizione gruppo: <b>{{ getDependantQuestionConditionLabel(childGroupQuestion) }}</b></p>
          <question-group-statistics
            :question-group="childGroupQuestion">
          </question-group-statistics>
        </div>
      </div>
      <div v-else>
        <p>Nessuna risposta</p>
      </div>
    </div>
  </div>
</template>
